"use client"

import { useState, useMemo } from "react"

// Shop names list
const shopNames = [
  "The Roving Tar",
  "The Mild Apocalypse",
  "The Sobbing Siren",
  "The Tipsy Treant",
  "The Jolly Impaler",
  "Ooze & Aahs Spa",
  "Ye Olde Bargain Bin",
  "The Vermilion Minotaur",
  "The Smouldering Widow",
  "Chu Chu's Chow",
  "Pint o' Poison",
  "Pretty Potties",
  "Studio 21",
  "The Crying Basilisk",
  "Rune & Groom",
  "Potion, Lotion & Devotion",
  "Ethereal Knees",
  "Dungeon & Donuts",
  "The Yawning Kraken",
  "Toad & Tonic",
  "Bureau of Plausible Deniability",
  "WandMart",
  "Gnome Depot",
  "Amazone",
  "Alley Express",
]

interface ShopMerchantNameProps {
  scale: number
}

export const ShopMerchantName = ({ scale }: ShopMerchantNameProps) => {
  // Get a random shop name on mount (persists for this shop session)
  const [shopName] = useState(() =>
    shopNames[Math.floor(Math.random() * shopNames.length)]
  )

  // Calculate font size to fit within container
  // Scale down per extra character beyond 7 characters
  const baseFontSize = 8.5 * scale
  const fontSize = useMemo(() => {
    if (shopName.length > 7) {
      return baseFontSize * (7 / shopName.length)
    }
    return baseFontSize
  }, [shopName, baseFontSize])

  return (
    <div
      id="shop-merchant-name"
      className="absolute flex items-center justify-center text-white font-bold whitespace-nowrap overflow-hidden"
      style={{
        right: `${9 * scale}px`,
        bottom: `${20 * scale}px`,
        width: `${84 * scale}px`,
        height: `${16 * scale}px`,
        fontSize: `${Math.max(fontSize, 6 * scale)}px`, // Min font size
        textShadow: "1px 1px 2px rgba(0,0,0,0.8)",
      }}
    >
      {shopName}
    </div>
  )
}
